jQuery( document ).ready( function ( $ ) {

  subMenuSearch();

  //Flickity Options and init
  $('#slideshow').flickity({
    lazyLoad: 1,
    wrapAround: true,
    adaptiveHeight: false,
    imagesLoaded: true,
    autoPlay: 5000
  });

  //Menus
  //++=====================================================================

  
  $( '.menu-btn' ).click( function ( e ) { // hide/show menu for mobile
    e.preventDefault();
    if ( $( this ).hasClass( 'active' ) ) {
      $( '.nav-overlay' ).fadeOut( 250 );
      $( this ).removeClass( 'active' );
      $( '.main-nav' ).removeClass( 'active' );
      $( 'body' ).removeClass( 'menu-active' );
    } else {
      $( '.nav-overlay' ).fadeIn( 250 );
      $( this ).addClass( 'active' );
      $( '.main-nav' ).addClass( 'active' );
      $( 'body' ).addClass( 'menu-active' );
    }
  } );

  $( '.nav-overlay' ).click( function ( e ) { // hides mobile menu on overlay click
    e.preventDefault();
    $( '.nav-overlay' ).fadeOut( 250 );
    $( '.menu-btn' ).removeClass( 'active' );
    $( '.main-nav' ).removeClass( 'active' );
    $( 'body' ).removeClass( 'menu-active' );
  } );

  function subMenuSearch() { //looks for menu-items with sub menus
    $( '.menu-item-has-children' ).append( '<a href="#" class="sub-menu-btn">+</a>' );
  }

  $( 'body' ).on( 'click', '.sub-menu-btn', function ( e ) {
    e.preventDefault();
    console.log( $( this ).data( 'num' ) );

    if ( $( this ).hasClass( 'active' ) ) {
      $( this ).removeClass( 'active' );
      $( this ).siblings( '.sub-menu' ).removeClass( 'active-sub-menu' );
      $( this ).removeClass( 'active' );
    } else {
      $( this ).addClass( 'active' );
      $( this ).siblings( '.sub-menu' ).addClass( 'active-sub-menu' );
      $( this ).addClass( 'active' );
    }
  } );

} );


